// utils/auth.js

export const getLoggedCompany = () => {
  try {
    const data = localStorage.getItem("company");
    if (!data) return null;
    return JSON.parse(data);
  } catch (err) {
    console.error("Invalid company data");
    return null;
  }
};

export const isLoggedIn = () => {
  return !!getLoggedCompany();
};


export const logout = () => {
  localStorage.removeItem("company");
  window.location.replace("/login"); // hard redirect
};
